(function () {
  'use strict';

  var STORAGE_KEY = 'ayami_fabric_preferences';
  var PENDING_SAVE_KEY = 'fabric_preferences_pending_save';
  var RESUME_AFTER_LOGIN_KEY = 'fabric_prefs_resume_after_login';
  var AUTO_SAVE_PARAM = 'fabric_prefs_auto_save';
  var SAVE_PATH = '/apps/ayami-color-guide/fabric-save';
  var DEFAULT_NEXT_URL = '/pages/onboarding?from=fabric-prefs';
  var DEFAULT_NEXT_LABEL = 'Continue';
  var ONBOARDING_BRIDGE_KEY = 'ayami_onboarding_bridge';
  var VALID_VOTES = { love: true, acceptable: true, not_for_me: true };
  var VOTE_LABELS = {
    love: 'Love it',
    acceptable: 'Acceptable',
    not_for_me: 'Not for me',
  };

  function normalizeVote(raw) {
    var vote = String(raw || '').trim().toLowerCase();
    if (VALID_VOTES[vote]) return vote;
    if (vote === 'like') return 'love';
    if (vote === 'dislike') return 'not_for_me';
    return '';
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function isHtmlResponse(text) {
    var trimmed = String(text || '').trim().toLowerCase();
    return trimmed.indexOf('<!doctype') === 0 || trimmed.indexOf('<html') === 0;
  }

  function resolveSaveUrl(raw) {
    var path = SAVE_PATH;
    try {
      if (raw) {
        if (/^https?:\/\//i.test(raw)) {
          var absolute = new URL(raw);
          if (absolute.origin === window.location.origin) {
            path = absolute.pathname;
          }
        } else if (String(raw).charAt(0) === '/') {
          path = String(raw).split('?')[0];
        }
      }
    } catch (e) {
      path = SAVE_PATH;
    }
    path = path.replace(/^\/(en|es|fr|de|ca|it|pl|sv)(?=\/apps\/)/i, '');
    if (path.indexOf('/apps/ayami-color-guide/fabric-save') !== 0) {
      path = SAVE_PATH;
    }
    return new URL(path, window.location.origin).toString();
  }

  function getConfig(root) {
    return {
      loggedIn: root.getAttribute('data-customer-logged-in') === 'true',
      customerId: root.getAttribute('data-customer-id') || null,
      saveUrl: resolveSaveUrl(root.getAttribute('data-save-url')),
      loginUrl: root.getAttribute('data-login-url') || '/account/login',
      registerUrl: root.getAttribute('data-register-url') || '/account/register',
      prefsPage: root.getAttribute('data-prefs-page') || window.location.pathname,
      nextUrl: root.getAttribute('data-next-url') || DEFAULT_NEXT_URL,
      nextLabel: root.getAttribute('data-next-label') || DEFAULT_NEXT_LABEL,
    };
  }

  function readSavedFromPage() {
    var scriptEl = document.getElementById('FabricPreferencesSavedData');
    if (!scriptEl || !scriptEl.textContent.trim()) return null;
    try {
      var data = JSON.parse(scriptEl.textContent);
      // Some Liquid/json metafield paths double-encode as a string.
      if (typeof data === 'string') {
        try {
          data = JSON.parse(data);
        } catch (e2) {
          return null;
        }
      }
      return data && typeof data === 'object' ? data : null;
    } catch (e) {
      return null;
    }
  }

  function loadLocal() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      return JSON.parse(raw);
    } catch (e) {
      return null;
    }
  }

  function saveLocal(payload) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
    } catch (e) {
      /* ignore */
    }
  }

  function normalizePayload(raw) {
    if (!raw || typeof raw !== 'object') return null;
    var fabrics = Array.isArray(raw.fabrics) ? raw.fabrics : [];
    fabrics = fabrics
      .map(function (item) {
        if (!item || typeof item !== 'object') return null;
        var handle = String(item.handle || '').trim();
        var vote = normalizeVote(item.vote);
        if (!handle || !vote) return null;
        return {
          handle: handle,
          label: String(item.label || handle),
          vote: vote,
        };
      })
      .filter(Boolean);
    return {
      fabrics: fabrics,
      updated_at: raw.updated_at || null,
      page: raw.page || '',
    };
  }

  function setCardVote(card, vote) {
    var next = normalizeVote(vote);
    // Switch between options; keep selection when re-clicking the same rating.
    card.setAttribute('data-vote', next);
    card.classList.toggle('is-love', next === 'love');
    card.classList.toggle('is-acceptable', next === 'acceptable');
    card.classList.toggle('is-not_for_me', next === 'not_for_me');
    // Clear legacy classes if present from older markup
    card.classList.remove('is-like', 'is-dislike');
    Array.prototype.forEach.call(card.querySelectorAll('[data-fabric-vote]'), function (btn) {
      var pressed = btn.getAttribute('data-fabric-vote') === next;
      btn.setAttribute('aria-pressed', pressed ? 'true' : 'false');
    });
  }

  function applySaved(grid, saved) {
    if (!saved || !Array.isArray(saved.fabrics)) return;
    saved.fabrics.forEach(function (item) {
      var card = grid.querySelector('[data-fabric-handle="' + item.handle + '"]');
      if (!card) return;
      setCardVote(card, item.vote);
    });
  }

  function readCardVote(card) {
    if (!card) return '';
    var vote = normalizeVote(card.getAttribute('data-vote'));
    if (vote) return vote;
    var pressed = card.querySelector('[data-fabric-vote][aria-pressed="true"]');
    return pressed ? normalizeVote(pressed.getAttribute('data-fabric-vote')) : '';
  }

  function buildPayload(root, grid) {
    var fabrics = [];
    Array.prototype.forEach.call(grid.querySelectorAll('[data-fabric-card]'), function (card) {
      var vote = readCardVote(card);
      var handle = String(card.getAttribute('data-fabric-handle') || '').trim();
      if (!vote || !handle) return;
      fabrics.push({
        handle: handle,
        label: card.getAttribute('data-fabric-label') || handle,
        vote: vote,
      });
    });
    return {
      fabrics: fabrics,
      updated_at: new Date().toISOString(),
      page: root.getAttribute('data-prefs-page') || window.location.pathname,
      customer_id: root.getAttribute('data-customer-id') || null,
    };
  }

  function buildResultHtml(payload, options) {
    options = options || {};
    // Match on-page scale: Not for me (left) → Love it (right).
    var order = ['not_for_me', 'acceptable', 'love'];

    if (!payload.fabrics.length) {
      if (options.savedPage) {
        return (
          '<div class="fabric-prefs__empty">' +
            '<p>You have not rated any fabrics yet.</p>' +
            '<div class="fabric-prefs__actions" style="margin-top:1.6rem">' +
              '<a class="button" href="' + escapeHtml(options.prefsPage || '/pages/fabric-rating') + '">Rate fabrics</a>' +
            '</div>' +
          '</div>'
        );
      }
      return '<h2>Saved</h2><p>No fabric ratings yet — you can update this anytime.</p>';
    }

    var html = options.savedPage ? '' : '<h2>Your fabric rating is saved</h2>';
    if (options.savedBanner) {
      html += '<p class="fabric-prefs__hint" role="status">' + escapeHtml(options.savedBanner) + '</p>';
    }

    function chips(items, vote) {
      return items.map(function (item) {
        return (
          '<li class="fabric-prefs__result-chip' +
          (vote === 'not_for_me' ? ' fabric-prefs__result-chip--not_for_me' : '') +
          '">' +
          '<span>' + escapeHtml(item.label || item.handle) + '</span>' +
          '<span aria-hidden="true">(' + escapeHtml(VOTE_LABELS[vote] || vote) + ')</span>' +
          '</li>'
        );
      }).join('');
    }

    html += '<ul class="fabric-prefs__result-list">';
    order.forEach(function (vote) {
      var items = payload.fabrics.filter(function (f) { return f.vote === vote; });
      html += chips(items, vote);
    });
    html += '</ul>';

    if (!options.savedPage && options.nextUrl) {
      html +=
        '<div style="margin-top:2rem">' +
          '<a class="button" href="' + escapeHtml(options.nextUrl) + '">' +
            escapeHtml(options.nextLabel || DEFAULT_NEXT_LABEL) +
          '</a>' +
        '</div>';
    }

    if (options.savedPage && options.prefsPage) {
      html +=
        '<div class="fabric-prefs__actions" style="margin-top:1.6rem">' +
          '<a class="button button--secondary" href="' + escapeHtml(options.prefsPage) + '">Update fabric rating</a>' +
        '</div>';
    }

    return html;
  }

  function storePending(payload) {
    saveLocal(payload);
    try {
      sessionStorage.setItem(PENDING_SAVE_KEY, JSON.stringify(payload));
    } catch (e) {
      /* ignore */
    }
  }

  function readPending() {
    try {
      var raw = sessionStorage.getItem(PENDING_SAVE_KEY);
      if (!raw) return null;
      return JSON.parse(raw);
    } catch (e) {
      return null;
    }
  }

  function clearPending() {
    try {
      sessionStorage.removeItem(PENDING_SAVE_KEY);
    } catch (e) {
      /* ignore */
    }
  }

  function redirectToLogin(config) {
    // New Customer Accounts often ignore return_url and land on /account or Preferences.
    // Flag + pending payload let fabric-rating (or Preferences) resume save → bridge.
    try {
      sessionStorage.setItem(RESUME_AFTER_LOGIN_KEY, '1');
    } catch (e) {
      /* ignore */
    }

    var returnPath = config.prefsPage || window.location.pathname || '/pages/fabric-rating';
    try {
      var parsed = new URL(returnPath, window.location.origin);
      parsed.searchParams.set(AUTO_SAVE_PARAM, '1');
      returnPath = parsed.pathname + parsed.search + parsed.hash;
    } catch (e) {
      var separator = returnPath.indexOf('?') >= 0 ? '&' : '?';
      returnPath = returnPath + separator + AUTO_SAVE_PARAM + '=1';
    }

    var loginUrl = config.loginUrl || '/account/login';
    var q =
      'return_to=' +
      encodeURIComponent(returnPath) +
      '&return_url=' +
      encodeURIComponent(returnPath) +
      '&checkout_url=' +
      encodeURIComponent(returnPath);
    window.location.href =
      loginUrl + (loginUrl.indexOf('?') >= 0 ? '&' : '?') + q;
  }

  /** Always the fabric-prefs onboarding bridge — never Preferences / account. */
  function resolveOnboardingNextUrl(config) {
    var raw = (config && config.nextUrl) || DEFAULT_NEXT_URL;
    try {
      var parsed = new URL(raw, window.location.origin);
      var path = parsed.pathname.replace(/\/+$/, '');
      if (
        /\/pages\/preferences$/i.test(path) ||
        /\/account$/i.test(path) ||
        path === '' ||
        path === '/'
      ) {
        return DEFAULT_NEXT_URL;
      }
      if (!parsed.searchParams.get('from')) {
        parsed.searchParams.set('from', 'fabric-prefs');
      }
      return parsed.pathname + parsed.search + parsed.hash;
    } catch (e) {
      if (String(raw).indexOf('from=') >= 0) return String(raw);
      return DEFAULT_NEXT_URL;
    }
  }

  function postPreferences(saveUrl, payload, attempt) {
    var url = saveUrl || resolveSaveUrl('');
    attempt = attempt || 0;
    var body = {
      preferences: payload,
      customer_id: payload && payload.customer_id ? payload.customer_id : null,
    };
    return fetch(url, {
      method: 'POST',
      redirect: 'manual',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(body),
    }).then(function (res) {
      if (
        res.type === 'opaqueredirect' ||
        res.status === 301 ||
        res.status === 302 ||
        res.status === 303 ||
        res.status === 307 ||
        res.status === 308
      ) {
        var redirectError = new Error('Save was redirected (session may have expired)');
        redirectError.status = res.status || 401;
        throw redirectError;
      }
      return res.text().then(function (text) {
        if (isHtmlResponse(text)) {
          var htmlError = new Error('Save endpoint returned HTML instead of JSON');
          htmlError.status = res.status;
          htmlError.html = true;
          throw htmlError;
        }
        var body = {};
        if (text) {
          try {
            body = JSON.parse(text);
          } catch (e) {
            var parseError = new Error('Save endpoint returned invalid JSON');
            parseError.status = res.status;
            throw parseError;
          }
        }
        if (!res.ok || !body || body.ok === false) {
          var message =
            (body && (body.detail || body.error)) ||
            (res.status === 404
              ? 'fabric-save is not on the live app proxy — redeploy worker + set Proxy URL'
              : 'Save failed');
          if (
            res.status === 404 ||
            (body && String(body.error || '') === 'Not found')
          ) {
            message =
              'Live save server is missing fabric-save. In the Shopify app, set App proxy URL to ' +
              'https://color-guide-save.ayami.workers.dev/proxy and redeploy secrets.';
          }
          var error = new Error(message);
          error.status = res.status;
          error.detail = message;
          throw error;
        }
        return body;
      });
    }).catch(function (error) {
      if (attempt < 1 && error && (error.html || error.status === 401 || error.status === 404)) {
        return new Promise(function (resolve) {
          setTimeout(resolve, 600);
        }).then(function () {
          return postPreferences(url, payload, attempt + 1);
        });
      }
      throw error;
    });
  }

  function continueToNextStep(config, hintEl, payload) {
    var nextUrl = resolveOnboardingNextUrl(config);
    if (!nextUrl) return false;
    try {
      var highlights = (payload.fabrics || [])
        .filter(function (f) { return f.vote === 'love' || f.vote === 'acceptable'; })
        .map(function (f) {
          var label = f.label || f.handle;
          return label + ' — ' + (VOTE_LABELS[f.vote] || f.vote);
        });
      sessionStorage.setItem(
        ONBOARDING_BRIDGE_KEY,
        JSON.stringify({ from: 'fabric-prefs', highlights: highlights })
      );
    } catch (e) {
      /* ignore */
    }
    try {
      sessionStorage.removeItem(RESUME_AFTER_LOGIN_KEY);
    } catch (e2) {
      /* ignore */
    }
    if (hintEl) {
      hintEl.textContent = 'Continuing…';
      hintEl.classList.remove('is-error');
    }
    // Shared onboarding bridge owns next-step / skip routing (never Preferences).
    window.location.replace(nextUrl);
    return true;
  }

  function submitForm(root, form, grid, hintEl, resultEl, config) {
    var payload = buildPayload(root, grid);
    if (!payload.fabrics.length) {
      if (hintEl) {
        hintEl.textContent = 'Rate at least one fabric (Love it, Acceptable, or Not for me).';
        hintEl.classList.add('is-error');
      }
      return;
    }

    if (!config.loggedIn) {
      storePending(payload);
      if (hintEl) {
        hintEl.textContent = 'Redirecting you to log in so we can save your preferences…';
        hintEl.classList.remove('is-error');
      }
      redirectToLogin(config);
      return;
    }

    saveLocal(payload);
    var submitBtn = form.querySelector('[data-fabric-prefs-submit]');
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.setAttribute('aria-busy', 'true');
    }
    if (hintEl) {
      hintEl.textContent = 'Saving…';
      hintEl.classList.remove('is-error');
    }

    var redirecting = false;
    var bridgeNextUrl = resolveOnboardingNextUrl(config);

    postPreferences(config.saveUrl, payload)
      .then(function () {
        clearPending();
        if (resultEl) {
          resultEl.innerHTML = buildResultHtml(payload, {
            nextUrl: bridgeNextUrl,
            nextLabel: config.nextLabel,
          });
          resultEl.classList.remove('hidden');
        }
        if (continueToNextStep(config, hintEl, payload)) {
          redirecting = true;
          return;
        }
        if (hintEl) hintEl.textContent = '';
        if (resultEl) {
          resultEl.focus();
          resultEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      })
      .catch(function (error) {
        if (error && error.status === 401) {
          storePending(payload);
          redirectToLogin(config);
          return;
        }
        if (hintEl) {
          hintEl.textContent =
            (error && (error.detail || error.message)) ||
            'Could not save. Please try again.';
          hintEl.classList.add('is-error');
        }
      })
      .finally(function () {
        if (redirecting) return;
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.removeAttribute('aria-busy');
        }
      });
  }

  function initQuiz() {
    var root = document.querySelector('[data-fabric-prefs]');
    if (!root) return;
    var form = root.querySelector('[data-fabric-prefs-form]');
    var grid = root.querySelector('[data-fabric-prefs-grid]');
    if (!form || !grid) return;

    var hintEl = root.querySelector('[data-fabric-prefs-hint]');
    var resultEl = root.querySelector('[data-fabric-prefs-result]');
    var config = getConfig(root);

    var saved = normalizePayload(readSavedFromPage()) || normalizePayload(loadLocal());
    if (saved) applySaved(grid, saved);

    grid.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-fabric-vote]');
      if (!btn) return;
      var card = btn.closest('[data-fabric-card]');
      if (!card) return;
      setCardVote(card, btn.getAttribute('data-fabric-vote'));
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      submitForm(root, form, grid, hintEl, resultEl, config);
    });

    var params = new URLSearchParams(window.location.search);
    var resumeFlag = false;
    try {
      resumeFlag = sessionStorage.getItem(RESUME_AFTER_LOGIN_KEY) === '1';
    } catch (e) {
      resumeFlag = false;
    }
    var shouldResume =
      config.loggedIn &&
      (params.get(AUTO_SAVE_PARAM) === '1' || resumeFlag);

    if (shouldResume) {
      try {
        sessionStorage.removeItem(RESUME_AFTER_LOGIN_KEY);
      } catch (e2) {
        /* ignore */
      }
      var pending = normalizePayload(readPending()) || saved;
      if (pending && pending.fabrics.length) {
        applySaved(grid, pending);
        if (hintEl) {
          hintEl.textContent = 'Finishing your save…';
          hintEl.classList.remove('is-error');
        }
        submitForm(root, form, grid, hintEl, resultEl, config);
      }
      try {
        var clean =
          window.location.pathname +
          window.location.search
            .replace(new RegExp('([?&])' + AUTO_SAVE_PARAM + '=1&?'), '$1')
            .replace(/[?&]$/, '');
        window.history.replaceState({}, '', clean || window.location.pathname);
      } catch (e3) {
        /* ignore */
      }
    }
  }

  function initSavedPage() {
    var root = document.querySelector('[data-fabric-prefs-saved]');
    if (!root) return;
    var target = root.querySelector('[data-fabric-prefs-saved-content]');
    if (!target) return;

    var config = {
      loggedIn: root.getAttribute('data-customer-logged-in') === 'true',
      prefsPage: root.getAttribute('data-prefs-page') || '/pages/fabric-rating',
      loginUrl: root.getAttribute('data-login-url') || '/account/login',
      registerUrl: root.getAttribute('data-register-url') || '/account/register',
    };

    // Login often lands on Preferences — bounce to fabric-rating to finish save → bridge.
    if (config.loggedIn) {
      var resumeOnPrefs = false;
      try {
        resumeOnPrefs = sessionStorage.getItem(RESUME_AFTER_LOGIN_KEY) === '1';
      } catch (e) {
        resumeOnPrefs = false;
      }
      var pendingOnPrefs = normalizePayload(readPending());
      if (resumeOnPrefs && pendingOnPrefs && pendingOnPrefs.fabrics.length) {
        var ratingUrl = config.prefsPage || '/pages/fabric-rating';
        var sep = ratingUrl.indexOf('?') >= 0 ? '&' : '?';
        window.location.replace(ratingUrl + sep + AUTO_SAVE_PARAM + '=1');
        return;
      }
    }

    if (!config.loggedIn) {
      target.innerHTML =
        '<div class="fabric-prefs__empty">' +
          '<p>Log in to view your fabric rating.</p>' +
          '<div class="fabric-prefs__actions" style="margin-top:1.6rem">' +
            '<a class="button" href="' + escapeHtml(config.loginUrl) + '">Log in</a>' +
            '<a class="button button--secondary" href="' + escapeHtml(config.registerUrl) + '">Create account</a>' +
          '</div>' +
        '</div>';
      if (typeof window.kailaRefreshPreferencesHub === 'function') {
        window.kailaRefreshPreferencesHub();
      }
      return;
    }

    var payload = normalizePayload(readSavedFromPage()) || normalizePayload(loadLocal());
    if (!payload) {
      target.innerHTML = buildResultHtml({ fabrics: [] }, { savedPage: true, prefsPage: config.prefsPage });
    } else {
      saveLocal(payload);
      var params = new URLSearchParams(window.location.search);
      target.innerHTML = buildResultHtml(payload, {
        savedPage: true,
        prefsPage: config.prefsPage,
        savedBanner: params.get('fabric_prefs_saved') === '1' ? 'Your fabric rating has been saved.' : '',
      });
    }

    if (typeof window.kailaRefreshPreferencesHub === 'function') {
      window.kailaRefreshPreferencesHub();
    }
  }

  function boot() {
    initQuiz();
    initSavedPage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
